import { McqMainSection } from "./MainSection";
import { ActiveSession } from "./ActiveSession";
import { PerformanceDetails } from "./PerformanceDetails";

export const containers = {
  McqMainSection,
  ActiveSession,
  PerformanceDetails,
};



// WEBPACK FOOTER //
// ./src/modules/mcq/containers/index.js